module.exports = __webpack_public_path__ + "1adcfee167695b2a0f9a68a20992e612.jpg";